import { z } from 'zod';
import { SourceRefSchema, about, icon, sourceOf } from '../schema_fields.ts';

/**
 * An action (legacy `ActionTile`): a button that shows no state; a tap sends one command, with an
 * optional argument, to its source's driver (the owner, 2026-10-15). Which commands there are is
 * the driver's: the Hubitat driver takes the device's own (`push` with a button number, `refresh`).
 */
export const ActionOptionsSchema = z.object({
    source: sourceOf(SourceRefSchema, { gives: [], commands: true, label: 'Device' }),
    command: z.string().min(1).meta(about('Command', 'what a tap sends to the device', 'command')),
    argument: z.union([z.string(), z.number(), z.boolean()]).optional().meta(about('Argument', 'sent with the command, if it takes one', 'command-argument')),
    icon: icon('Icon', 'toggle-large-on'),
});
